import $ from '../$';
import removeData from '../functions/removeData';
import './each';
$.fn.removeData = function (name) {
    return this.each(function () {
        removeData(this, name);
    });
};
